import { Link, Typography } from '@iheartjane/reefer';

import {
  getJaneGoldFAQPath,
  getJaneGoldLandingPath,
} from '../../utils/gold/getBrandSpecialPaths';

interface JaneGoldLearnMoreLinkProps {
  /** Optionally display this text using text-light and mini font variant */
  finePrint?: boolean;
  /** Optional text for hyperlinked text */
  label?: string;
  /** Indicates if the user has a linked bank or not. Depending on it, it will render different content or calls to action */
  userHasLinkedBank: boolean | undefined;
}

export const JaneGoldLearnMoreLink = ({
  label = 'Learn more',
  finePrint = false,
  userHasLinkedBank,
}: JaneGoldLearnMoreLinkProps) => {
  const learnMoreLink = userHasLinkedBank
    ? getJaneGoldFAQPath()
    : getJaneGoldLandingPath();

  return (
    <Link
      href={learnMoreLink}
      data-testid="learn-more-link"
      color={finePrint ? 'text-light' : 'text-main'}
    >
      <Typography
        as="span"
        variant={finePrint ? 'small-body-regular' : 'body-regular'}
        color={finePrint ? 'text-light' : 'text-main'}
      >
        {label}
      </Typography>
    </Link>
  );
};
